var _path, _path2, _path3, _path4, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H29C33 13 33 11.75 33 10.5C33 8 31 8 29 8H21C19 8 17 8 17 10.5C17 13 19 13 21 13Z",
    fill: "#E0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6201 33L22.6201 36L30.6201 28",
    stroke: "#1552E8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H29C33 13 33 11 33 9C33 5 31 5 29 5H21C19 5 17 5 17 9C17 13 19 13 21 13Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9.03906C39.66 9.39906 43 11.8591 43 20.9991V32.9991C43 40.9991 41 44.9991 31 44.9991H19C9 44.9991 7 40.9991 7 32.9991V20.9991C7 11.8791 10.34 9.39906 17 9.03906",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 17.5,
    x2: 32.5,
    y2: 17.5,
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 20.5,
    x2: 30.5,
    y2: 20.5,
    stroke: "#A020FF",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 23.5,
    x2: 27.5,
    y2: 23.5,
    stroke: "#A020FF",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.311ae3869045abbc1ca52da27ae002d4.svg";
export { ForwardRef as ReactComponent };